import { Auth0ProviderOptions } from '@auth0/auth0-react';
import { env } from 'src/env';

export const auth0Config: Auth0ProviderOptions = {
    domain: env.REACT_APP_AUTH0_DOMAIN,
    clientId: env.REACT_APP_AUTH0_CLIENTID,
    cacheLocation: 'memory',
    authorizationParams: {
        // eslint-disable-next-line camelcase
        redirect_uri: env.REACT_APP_APP_BASE_URL, // Redirect URL is dynamic, so setting it on login call
        audience: env.REACT_APP_AUTH0_AUDIENCE,
    },
};